import type { FileUploadService } from '../application/FileUploadService';
import { UPLOAD_PATHS } from '../application/FileUploadService';

const FORM_DATA_NAME = 'file';

export class HttpFileUploadService implements FileUploadService {
  private readonly baseApiUrl: string;

  constructor({ baseApiUrl }: { baseApiUrl: string }) {
    this.baseApiUrl = baseApiUrl;
  }

  private uploadFile = async ({ file, url }: { file: File; url: string }) => {
    const formData = new FormData();
    formData.append(FORM_DATA_NAME, file);

    const response = await fetch(url, {
      method: 'POST',
      body: formData,
      credentials: 'include',
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(`File upload failed: ${text}`);
    }

    const { path } = await response.json();
    return path;
  };

  uploadCv = (file: File) =>
    this.uploadFile({ file, url: `${this.baseApiUrl}${UPLOAD_PATHS.CV}` });

  uploadEligibilityProof = (file: File) =>
    this.uploadFile({
      file,
      url: `${this.baseApiUrl}${UPLOAD_PATHS.ELIGIBILITY_PROOF}`,
    });

  uploadEnrollmentPlanFile = (file: File) =>
    this.uploadFile({
      file,
      url: `${this.baseApiUrl}${UPLOAD_PATHS.ENROLLMENT_PLAN_FILE}`,
    });

  uploadDiversityFile = (file: File) =>
    this.uploadFile({
      file,
      url: `${this.baseApiUrl}${UPLOAD_PATHS.DIVERSITY_FILE}`,
    });
}
